/**
 * @enum LimitType - type of limit
 */
export enum LimitType {
    /**
     * @member Count
     */
    Count = <any>'count',

    /**
     * @member Amount
     */
    Amount = <any>'amount'
}



/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/LimitType.ts
 **/